import { AxiosResponse } from 'axios'
import { HTTP_STATUS } from '../enums/enums'

/**
 * Checks if an `AxiosResponse` is 2xx.
 *
 * @param {AxiosResponse<any, any>} response
 */
export const isResponseSuccessful = (response: AxiosResponse<any, any>): boolean => {
  return Math.floor(response.status / 100) === 2
}

/**
 * Checks if an `AxiosResponse` is 404.
 *
 * @param {AxiosResponse<any, any>} response
 */
export const isResponseNotFound = (response: AxiosResponse<any, any>): boolean => {
  return response.status === HTTP_STATUS.NOT_FOUND
}
